/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { ScoreCardSetScoreCardCreateRequest } from "./ScoreCardSetScoreCardCreateRequest"

/**
 * Serializer for ruleset model
 */
export type ScoreCardSetCreateUpdateRequest = {
  name: string
  /**
   * * `VALUE_BY_WEIGHT` - Value by Weight
   * * `NORMALIZED_VALUE_BY_WEIGHT` - Normalized value by weight
   */
  calculation_method: ScoreCardSetCreateUpdateRequest.calculation_method
  scorecards?: Array<ScoreCardSetScoreCardCreateRequest>
}
export namespace ScoreCardSetCreateUpdateRequest {
  /**
   * * `VALUE_BY_WEIGHT` - Value by Weight
   * * `NORMALIZED_VALUE_BY_WEIGHT` - Normalized value by weight
   */
  export enum calculation_method {
    VALUE_BY_WEIGHT = "VALUE_BY_WEIGHT",
    NORMALIZED_VALUE_BY_WEIGHT = "NORMALIZED_VALUE_BY_WEIGHT",
  }
}
